import { Http, Url } from '@intelipost-js/secure-providers';

export default {
  getOccurrences({ commit, state }, form) {
    const { logisticProviderId = null, file = null } = form;

    const formData = new FormData();

    if (file && file.file) {
      formData.append('file', file.file, file.file.name);
      formData.append('logisticProviderId', logisticProviderId);
    }

    commit('setLoading', true);

    return Http.post(Url.toQueryString('api/v1/proceda/ocoren/excel', null, [logisticProviderId]), formData)
      .then((res) => {
        commit('setLoading', false);
        commit('setDownloadLink', res.data.content);
      })
      .catch(() => commit('setLoading', false));
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/occurrences-validation/store/actions.js